import { ShieldCheck, MapPin, MessagesSquare, BadgeIndianRupee, Users, Building2 } from "lucide-react";

const items = [
  { icon: Users, label: "Trusted by local communities" },
  { icon: Building2, label: "Built for everyday city life" },
  { icon: ShieldCheck, label: "Secure OTP Login" },
  { icon: MapPin, label: "Location Based" },
  { icon: MessagesSquare, label: "Direct Communication" },
  { icon: BadgeIndianRupee, label: "No Hidden Commissions" },
];

export default function TrustBar() {
  return (
    <section className="py-10 border-y border-[#EBE8E3] bg-white">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {items.map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-2.5 text-[#4A4846]">
              <div className="w-9 h-9 rounded-full bg-[#FFF3ED] flex items-center justify-center flex-shrink-0">
                <Icon className="w-4.5 h-4.5 text-[#FF5A00]" />
              </div>
              <span className="text-sm font-semibold leading-tight">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
